import React from 'react';

import EmptyState from '@adsk/alloy-react-empty-state';

import RemoteSideNavigationErrorRetry from './RemoteSideNavigationErrorRetry';
import i18n from '../../utils/i18n';

const RemoteSideNavigationExpandedError = () => (
  <EmptyState
    title={i18n.t('SOMETHING_WENT_WRONG')}
    illustrationType={EmptyState.ILLUSTRATION_TYPES.BUILDING_CONSTRUCTION_GREY}
    size={EmptyState.SIZES.MEDIUM}
    style={{
      backgroundColor: 'transparent',
      flex: 1,
      padding: '20px 10px',
      img: {
        width: 120,
        height: 120,
      },
    }}
  >
    <RemoteSideNavigationErrorRetry />
  </EmptyState>
);

export default RemoteSideNavigationExpandedError;
